export async function PsqiCreate( 
    psqiResp,
        metaFecha,
        psqiPreg001,
        psqiPreg002,
        psqiPreg003,
        psqiPreg004,
        psqiPreg005a,
        psqiPreg005b,
        psqiPreg005c,
        psqiPreg005d,
        psqiPreg005e,
        psqiPreg005f,
        psqiPreg005g,
        psqiPreg005h,
        psqiPreg005i,
        psqiPreg005j,
        psqiPreg005k,
        psqiPreg006,
        psqiPreg007,
        psqiPreg008,
        psqiPreg009,
        psqiPreg010,
        psqiPreg010a,
        psqiPreg010b,
        psqiPreg010c,
        psqiPreg010d,
        psqiPreg010e,
        psqiPreg010f,
    tratamientoId,
    pacienteId
     ) {
    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-psqi-${metaFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-psqi-${metaFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            psqiResp: psqiResp,
        metaFecha: metaFecha,
        psqiPreg001: psqiPreg001,
        psqiPreg002: psqiPreg002,
        psqiPreg003: psqiPreg003,
        psqiPreg004: psqiPreg004,
        psqiPreg005a: psqiPreg005a,
        psqiPreg005b: psqiPreg005b,
        psqiPreg005c: psqiPreg005c,
        psqiPreg005d: psqiPreg005d,
        psqiPreg005e: psqiPreg005e,
        psqiPreg005f: psqiPreg005f,
        psqiPreg005g: psqiPreg005g,
        psqiPreg005h: psqiPreg005h,
        psqiPreg005i: psqiPreg005i,
        psqiPreg005j: psqiPreg005j,
        psqiPreg005k: psqiPreg005k,
        psqiPreg006: psqiPreg006,
        psqiPreg007: psqiPreg007,
        psqiPreg008: psqiPreg008,
        psqiPreg009: psqiPreg009,
        psqiPreg010: psqiPreg010,
        psqiPreg010a: psqiPreg010a,
        psqiPreg010b: psqiPreg010b,
        psqiPreg010c: psqiPreg010c,
        psqiPreg010d: psqiPreg010d,
        psqiPreg010e: psqiPreg010e,
        psqiPreg010f: psqiPreg010f
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/psqi', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}

export async function PsqiDraft(
  psqiResp,
  metaFecha,
  pacienteId
) {
  const formData = {
    title: `us-${pacienteId}-tr-tba-psqi-${metaFecha}`,
    slug: `us-${pacienteId}-tr-tba-psqi-${metaFecha}`,
    status: "draft",
    author: pacienteId,
    paciente: pacienteId,
    meta: {
      psqiResp: psqiResp,
      metaFecha: metaFecha,
    },
  };

  const authToken = sessionStorage.getItem( 'token' );

  try {
    const response = await fetch(
      "https://app.tavad.com/hce/wp-json/wp/v2/psqi",
      {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${ authToken }`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}

export async function PsqiSchedule(
  psqiResp,
  metaFecha,
  pacienteId,
  scheduledDate
) {
  const formData = {
    title: `us-${pacienteId}-tr-tba-psqi-${metaFecha}`,
    slug: `us-${pacienteId}-tr-tba-psqi-${metaFecha}`,
    status: "future",
    author: pacienteId,
    paciente: pacienteId,
    date: scheduledDate,
    meta: {
      psqiResp: psqiResp,
      metaFecha: metaFecha,
    },
  };

  const authToken = sessionStorage.getItem( 'token' );

  try {
    const response = await fetch(
      "https://app.tavad.com/hce/wp-json/wp/v2/psqi",
      {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${ authToken }`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
